var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useMemo } from 'react';
import { useOutlet } from 'react-router';
import { Helmet } from 'react-helmet';
import { t } from "../../../I18N";
import { SettingsNavigation } from "./SettingsNavigation";

const Settings = () => {
  const outlet = useOutlet();
  const isSettingsParentRoute = useMemo(() => outlet === null, [outlet]);
  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: {
        display: 'flex',
        width: 'calc(100% + 30px)',
        height: '100%',
        marginLeft: '-15px',
        marginRight: '-15px'
      } }, void 0, /*#__PURE__*/

    _jsx(Helmet, {}, void 0, /*#__PURE__*/
    _jsx("title", {}, void 0, t('System', 'Settings', null, false))
    ), /*#__PURE__*/
    _jsx("div", {
      className: `md:min-w-[250px] border-r border-gray-200 bg-gray-50 h-full ${isSettingsParentRoute ? 'w-full' : 'invisible w-0 min-w-0'} md:visible` }, void 0, /*#__PURE__*/

    _jsx(SettingsNavigation, {})
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 overflow-auto h-full" }, void 0, outlet)
    ));

};

export { Settings };